import React from "react";
import {
  Checkbox,
  Button,
  SimpleTable,
} from "@swordsweeper/ssi-ui-component-library";
import { useFormHandlers } from "@swordsweeper/react-forms";
import NotificationSettingTypeLabels from "./NotificationSettingTypeLabels";
import findIndex from "lodash/findIndex";

export default function AccountNotificationSettingsForm({
  initialData,
  onSubmit,
}) {
  const { formData, setFormData, isValid } = useFormHandlers(initialData);

  const handleUpdateUserNotificationSetting = (
    userNotificationSettingId,
    name,
    value,
  ) => {
    const userNotificationSettingIndex = findIndex(formData, {
      id: userNotificationSettingId,
    });
    if (userNotificationSettingIndex !== -1) {
      const updatedFormData = [...formData];
      updatedFormData[userNotificationSettingIndex][name] = value;
      setFormData(updatedFormData);
    }
  };

  return (
    <div>
      <div className="text-lg font-weight-bold padding-y-lg">
        How would you like to be notified?
      </div>
      <SimpleTable
        columns={[
          {
            header: "Type",
            key: "notificationType",
            render: ({ notificationType }) =>
              NotificationSettingTypeLabels[notificationType],
          },
          {
            header: "In-App",
            key: "inAppEnabled",
            render: ({ id, inAppEnabled }) => (
              <div id={`notification-setting-checkbox-in-app-${id}`}>
                <Checkbox
                  className="text-sm"
                  name="inApp"
                  checked={inAppEnabled}
                  onChange={(checked) =>
                    handleUpdateUserNotificationSetting(
                      id,
                      "inAppEnabled",
                      checked,
                    )
                  }
                  data-testid={`notification-setting-checkbox-in-app-${id}`}
                />
              </div>
            ),
          },
          {
            header: "Email",
            key: "email",
            render: ({ id, emailEnabled }) => (
              <div id={`notification-setting-checkbox-email-${id}`}>
                <Checkbox
                  className="text-sm"
                  name="email"
                  checked={emailEnabled}
                  onChange={(checked) =>
                    handleUpdateUserNotificationSetting(
                      id,
                      "emailEnabled",
                      checked,
                    )
                  }
                  data-testid={`notification-setting-checkbox-email-${id}`}
                />
              </div>
            ),
          },
          {
            header: "Text",
            key: "text",
            render: ({ id, textEnabled }) => (
              <div id={`notification-setting-checkbox-text-${id}`}>
                <Checkbox
                  className="text-sm"
                  name="text"
                  checked={textEnabled}
                  onChange={(checked) =>
                    handleUpdateUserNotificationSetting(
                      id,
                      "textEnabled",
                      checked,
                    )
                  }
                  data-testid={`notification-setting-checkbox-text-${id}`}
                />
              </div>
            ),
          },
        ]}
        data={formData}
      />
      <div className="margin-top-xl">
        <Button
          className="btn btn-primary btn-md"
          label="Save Changes"
          onClick={() => onSubmit(formData)}
          disabled={!isValid}
        />
      </div>
    </div>
  );
}
